import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { WindowService } from '../../shared/window.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { OeAppService } from '../../shared/oe-app.service';
import { TranslationService } from '../../shared/translation.service';
import { PlatformTourService } from '../platform-tour-service/platform-tour.service';
import { isIFrameSameOrigin } from '../../shared/helpers/is-same-origin';

export const enum PlatformTourEventType {
  OPEN_PDF = 'PTOpenPdf',
  OPEN_ZOOM = 'PTOpenZoom',
  SCHEDULE = 'PTSchedule',
  SIGN_UP = 'PTSignUp',
  LANGUAGE_MODAL_CLOSED = 'PTLanguageModalClosed'
}

export const videoTourEnabled = true;

@Component({
  selector: 'lp2-platform-tour-page',
  template: `
    <section class="h-100 w-100">
      <iframe lp2UserwaySync class="border-0 h-100 w-100" [src]="platformTourPageFrameUrl | safeUrl"></iframe>
    </section>
  `,
  styles: [
    `
      :host {
        flex: 1;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformTourPageComponent implements OnInit, OnDestroy {
  public platformTourPageFrameUrl: string;

  constructor(
    private oeApp: OeAppService,
    private oeAppPersonService: OeAppPersonService,
    private translationService: TranslationService,
    private windowService: WindowService,
    private readonly platformTourService: PlatformTourService
  ) {}

  ngOnInit() {
    this.platformTourPageFrameUrl =
      `${this.oeApp.webPlatformTourHost}` +
      `?env=${this.oeApp.environment}` +
      `&personId=${this.oeAppPersonService.id}` +
      `&lang=${this.oeAppPersonService.preferredLang}` +
      `&videoTourEnabled=${videoTourEnabled}`;

    window.addEventListener('message', this.handleEvents.bind(this), false);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.handleEvents);
  }

  public handleEvents({ data, origin }) {

    if (!isIFrameSameOrigin(this.oeApp.webPlatformTourHost, origin)) {
      return;
    }

    const type: PlatformTourEventType = data.type;
    switch (type) {
      case PlatformTourEventType.OPEN_PDF:
        const zoomGuideUrl = this.translationService.translate('url.zoomGuide');
        this.windowService.openUrl(zoomGuideUrl);
        break;
      case PlatformTourEventType.OPEN_ZOOM:
        const zoomTest = this.translationService.translate('url.zoomTest');
        this.windowService.openUrl(zoomTest);
        break;
      case PlatformTourEventType.SCHEDULE:
        const slotSelected = data.data.slotSelected;
        break;
      case PlatformTourEventType.SIGN_UP:
        const meetingLink = data.data.meetingLink;
        if (!meetingLink) {
          return;
        }
        this.windowService.openUrl(meetingLink);
        break;
      case PlatformTourEventType.LANGUAGE_MODAL_CLOSED:
        window.history.back();
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/platform-tour/platform-tour-page/platform-tour-page.component.ts